module.exports = __webpack_public_path__ + "static/media/folder-icon.7574240b.svg";